/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoAlertWrapper implements angular.IDirective {
        restrict = "E";
        scope = {
            currentContext: '=?',
            currentClient: '=?',
            clientId: "=?",
            peekAlert: '=?',
            expandAlerts: '=?',
            noteType: '=?',
        };

        templateUrl = 'app/components/controls/clientAlertWrapper/alertWrapperTemplate.html';

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            if (_.isUndefined(scope.expandAlerts)) {
                scope.expandAlerts = false;
            }
        }

        static factory(): angular.IDirectiveFactory {
            let directive = () => new MeevoAlertWrapper();
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoAlertWrapper", MeevoAlertWrapper.factory());
}
